import { render } from "./LesApprenantsPage.vue?vue&type=template&id=5017221d"
import script from "./LesApprenantsPage.vue?vue&type=script&lang=js"
export * from "./LesApprenantsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__